module.exports = __webpack_public_path__ + "img/qrcode.1c2e8a3b.png";